import { useParams } from "react-router-dom";
import Layout from "../layout/Layout";
import TenantNotFoundPage from "../../pages/TenantNotFoundPage";
import { TenantSlugProvider, useTenantSlug } from "../../context/TenantSlugContext";

const TenantSlugGate = () => {
  const { isResolvingTenant, tenantNotFound } = useTenantSlug();

  if (isResolvingTenant) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (tenantNotFound) {
    return <TenantNotFoundPage />;
  }

  return <Layout />;
};

const TenantScopedLayout = () => {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();

  if (!tenantSlug) {
    return <TenantNotFoundPage />;
  }

  return (
    <TenantSlugProvider tenantSlug={tenantSlug}>
      <TenantSlugGate />
    </TenantSlugProvider>
  );
};

export default TenantScopedLayout;
